import {Injectable, Injector} from '@angular/core';
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {

    private _translate: TranslateService | undefined;

    constructor(
        private readonly _messageService: MessageService,
        private readonly _injector: Injector) {
    }

    private get translate(): TranslateService {
        if (!this._translate) {
            this._translate = this._injector.get(TranslateService);
        }
        return this._translate;
    }

    public Error(message: string, duration: number = 4000): void {
        this._messageService.add({
            severity: 'error',
            detail: message,
            life: duration,
        });
    }

    public Warning(message: string, duration: number = 4000): void {
        this._messageService.add({
            severity: 'warn',
            detail: message,
            life: duration,
        });
    }

    public Success(message: string, duration: number = 4000): void {
        this._messageService.add({
            severity: 'success',
            detail: message,
            life: duration,
        });
    }

    public Saved(duration: number = 2000): void {
        this._messageService.add({
            severity: 'success',
            detail: this.translate.instant('snackbar.saved'),
            life: duration,
        });
    }

    public Deleted(duration: number = 2000): void {
        this._messageService.add({
            severity: 'success',
            detail: this.translate.instant('snackbar.deleted'),
            life: duration,
        });
    }
}
